export default "__VITE_ASSET__Q3poyJ6h__";